/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type AgencyClubsControllerListAgencyClubsV1Relationship = typeof AgencyClubsControllerListAgencyClubsV1Relationship[keyof typeof AgencyClubsControllerListAgencyClubsV1Relationship];


export const AgencyClubsControllerListAgencyClubsV1Relationship = {
  strong: 'strong',
  active: 'active',
  cold: 'cold',
} as const;
